import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {API_URL} from "../../constants"

const Verification = () => {
  const { id, type } = useParams();
  const navigate = useNavigate();
  const [code, setCode] = useState(["", "", "", ""]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const token = localStorage.getItem("token")

  const handleSubmit = async () => {
    const otp = code.join("");
    if (otp.length !== 4) {
      setError("Please enter a 4-digit code");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(API_URL+
        "authy/verify_otp/",
        {
          id: id,
          otp: otp
        }, {
          headers: { 'Authorization': `Token ${token}` },
        }
      );
      console.log(response.data)
      if (response.data.status === 200) {
        navigate(`/home`);
      } else {
        setError(response.data.message || "Verification failed");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Verification error");
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    try {
      setResendLoading(true);
      const response = await axios.post(API_URL+
        "authy/resend_otp/",
        { id: id }, {
          headers: { 'Authorization': `Token ${token}` },
        }
      );
      
      if (response.data.status === 200) {
        alert("OTP resent successfully!");
      }
    } catch (err) {
      alert(err.response?.data?.message || "Error resending OTP");
    } finally {
      setResendLoading(false);
    }
  };

  
  const handleChange = (e, index) => {
    const newCode = [...code];
    // Only keep the last character entered
    newCode[index] = e.target.value.slice(-1);
    setCode(newCode);

    // If a value is entered, automatically focus the next input if it exists
    if (e.target.value && e.target.nextSibling) {
      e.target.nextSibling.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    // If backspace is pressed and the current input is empty, move focus to previous input and clear it
    if (e.key === "Backspace" && code[index] === "" && index > 0) {
      e.preventDefault(); // Prevent default backspace behavior
      const newCode = [...code];
      newCode[index - 1] = "";
      setCode(newCode);
      if (e.target.previousSibling) {
        e.target.previousSibling.focus();
      }
    }
  };


  // Keep existing handleChange and handleKeyDown functions

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="p-8 rounded-xl border border-gray-300 bg-white shadow-lg w-full max-w-md text-center">
        <h2 className="text-2xl font-semibold text-gray-700 mb-6">
          Verification
        </h2>

        {error && <div className="mb-4 text-red-500 text-sm">{error}</div>}

        <label className="block text-sm font-medium text-gray-600 mb-2">
          Secure code
        </label>

        <div className="flex justify-center gap-2 mb-4">
          {code.map((digit, index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="w-10 h-10 text-center border border-gray-300 rounded-md focus:ring-2 focus:ring-green-400 outline-none text-black"
            />
          ))}
        </div>

        <button
          style={{ boxShadow: "none" }}
          className="text-green-600 text-sm mb-4 hover:underline"
        
          onClick={handleResend}
          disabled={resendLoading}
        >
          {resendLoading ? "Sending..." : "Resend Code"}
        </button>

        <button
          onClick={handleSubmit}
          disabled={loading}
          className="w-full bg-teal-600 text-white py-2 mt-4 rounded-md hover:bg-teal-700 transition disabled:bg-gray-400"
        >
          {loading ? "Verifying..." : "Verify"}
        </button>
      </div>
    </div>
  );
};

export default Verification;